export const TICKETS_RESOLUTION_COLUMN_LIST = ['function_formatted_resolved_date', 'resolved_date', 'resolution_type'];

export const TICKETS_RESOLUTION_MEASURE_COLUMN_LIST = [{ name: 'time_spent', operation: 'floatSum' }];

// Tickets Aggregation Constants for getTicketData function
export const TICKETS_COLUMN_LIST = ['create_date_UserTimeZone_formatted', 'application_name'];

export const TICKETS_MEASURE_COLUMN_LIST = [
  { name: 'total_tickets', operation: 'sum' },
  { name: 'sev2_tickets', operation: 'sum' },
  { name: 'sev3_tickets', operation: 'sum' },
  { name: 'sev4_tickets', operation: 'sum' },
  { name: 'sev5_tickets', operation: 'sum' },
  { name: 'sev2_time_spent', operation: 'floatSum' },
  { name: 'total_time_spent', operation: 'floatSum' }
];
